<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.invoice.createStudentInvoice')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- Form -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.invoice.createStudentInvoice')}}</div>
                        <div class="text-right">
                            <b-button variant="primary" @click="createInvoice()">{{$t('button.save')}}</b-button>
                            <b-button variant="default" @click="$router.go(-1)">{{$t('button.cancel')}}</b-button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">

                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="InvoiceNumberField">{{$t('form.invoice.invoiceNumber')}}<span
                                            class="text-danger">*</span></label>
                                    <input id="InvoiceNumberField" type="text" v-model="invoice.InvoiceNumber"
                                        class="form-control" required="required" disabled>
                                </div>

                                <div class="form-group">
                                    <label for="StudentNameField">{{$t('form.invoice.student')}}<span
                                            class="text-danger">*</span></label>
                                    <ul class="list-group m-0">
                                        <div class="input-group">
                                            <input type="hidden" v-model="studentId">
                                            <input id="StudentNameField" type="text" class="form-control"
                                                placeholder="Search Student by Name"
                                                v-model="studentName"
                                                :class="{ 'is-invalid': $v.studentName.$error }"
                                                v-on:keyup="searchStudent()">
                                            <div class="input-group-append">
                                                <span class="input-group-text remove_btn" v-on:click="clear()">
                                                    <i class="fa fa-times"></i></span>
                                            </div>

                                        </div>
                                        <div class="invalid-feedback" v-if="!$v.studentName.required">
                                            {{$t('form.validation.required')}}</div>

                                        <li class="list-group-item" v-for="(student,index) in students" :key='index'>
                                            <a @click="selectedStudent(student)">
                                                {{student.StudentNumber}} - {{student.FirstName}} {{student.LastName}}
                                            </a>
                                        </li>

                                    </ul>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.mailAddress')}}</label><br>
                                    <b-form-radio v-model="invoice.MailAddress" value="1">
                                        {{$t('form.invoice.personalAddress')}}
                                    </b-form-radio>
                                    <b-form-radio v-model="invoice.MailAddress" value="2">
                                        {{$t('form.invoice.businessAddress')}}
                                    </b-form-radio>
                                </div>
                                <div class="form-group">

                                    <b-form-checkbox id="acceptance-fee" @change="showAcceptanceFee($event)" :disabled="!program.ID" v-model="administrative_fee_checkbox">
                                        {{$t('form.invoice.acceptanceFee')}}
                                    </b-form-checkbox>

                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.program')}}<span class="text-danger">*</span></label>
                                    <v-select v-if="program.FullTitle" @input="programSelected" label="FullTitle" :options="programs"
                                    v-model="program" :reduce="programs => programs"
                                    :class="{ 'is-invalid': $v.program.FullTitle.$error}"
                                    :disabled="true"
                                    ></v-select>
                                    <v-select v-if="!program.FullTitle" @input="programSelected" label="FullTitle" :options="programs"
                                    :reduce="programs => programs"
                                    :class="{ 'is-invalid': $v.program.FullTitle.$error}"
                                    :disabled="true"
                                    ></v-select>
                                       <div class="invalid-feedback" v-if="!$v.program.FullTitle.required">
                                        {{$t('form.validation.required')}}</div>

                                </div>

                                <div class="form-group" v-if="program.BillingCycle == 'course'||((program.BillingCycle=='inherit'||program.BillingCycle==null || program.BillingCycle=='') && tuition_fee_cycle=='course')">
                                    <label>{{$t('form.invoice.course')}}</label>
                                    <v-select label="FullTitle" @input="selectedCourse" :options="courses"
                                        v-model.trim="course" :reduce="courses => courses">
                                    </v-select>
                                </div>

                                <div class="form-group" v-else-if="program.BillingCycle == 'term'||((program.BillingCycle=='inherit'||program.BillingCycle==null || program.BillingCycle=='') && tuition_fee_cycle=='term')">
                                    <label>{{$t('form.invoice.terms')}}</label>
                                    <v-select :options="semesters"  :value="currentsemester" @input="selectedSemester($event)"
                                        :reduce="semesters => semesters"></v-select>
                                </div>

                                <!-- <label>{{$t('form.invoice.tuitionPurpose')}}</label>
                                <div class="form-group">
                                    <label for="MbaCourses">{{$t('form.invoice.MBACourses')}}</label>
                                    <v-select label="FullName" :options="mbaCourse" v-model="value"
                                        @input="setMBACourseTitle(value); mbaCoursePurpose()"
                                        :reduce="mbaCourse => mbaCourse.ProgramTitle">
                                    </v-select>
                                </div> -->

                                <!-- <div class="form-group">
                                    <label for="DateField">{{$t('form.invoice.date')}}</label>
                                    <date-picker :lang="lang" class="date-picker" v-model="mbaCourseDate"
                                        @change="mbaCoursePurpose()" valueType="format" :format="dateFormat">
                                    </date-picker>
                                </div> -->

                            </div>

                            <div class="col-md-12">

                                <div class="form-group">
                                    <label for="InvoicePurposeField">{{$t('form.invoice.invoicePurpose')}}<span class="text-danger">*</span></label>
                                    <v-select :options="invoicePurposes"
                                        v-model="InvoicePurpose" :reduce="invoicePurposes => invoicePurposes">
                                    </v-select>

                                    <div class="d-flex justify-content-between mt-2">
                                        <b-form-input v-model="newPurpose" :placeholder="$t('form.invoice.newPurpose')">
                                        </b-form-input>
                                        <b-button class="ml-2" variant="light" @click="addPurpose">{{$t('button.save')}}
                                        </b-button>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t('form.invoice.amount')}}<span class="text-danger">*</span></label>
                                    <input v-model="InvoiceAmount" v-on:keydown="addSeperator" v-on:blur="addSeperator"
                                        :class="{ 'is-invalid': $v.InvoiceAmount.$error }" type="text"
                                         class="form-control">
                                     <div class="invalid-feedback" v-if="!$v.InvoiceAmount.required">
                                        {{$t('form.validation.required')}}</div>
                                    <div class="invalid-feedback" v-if="!$v.InvoiceAmount.decimal">
                                        {{$t('form.validation.decimalAllowed')}}
                                    </div>
                                    <p class="text-muted" v-if="discount > 0">
                                        {{$t('form.invoice.globalDiscountInfo', {discount: discount})}}</p>
                                </div>

                                <div class="form-group" v-if="program.ID &&
                                                        student.GlobalDiscount &&
                                                        student.GlobalDiscount > 0">
                                    <b-form-checkbox id="excludeScholarshipReduction"
                                    :disabled="!program.ID" v-model="invoice.excludeScholarshipReduction">
                                            {{$t('form.invoice.exclude_scholarship_reduction')}}
                                    </b-form-checkbox>
                                </div>

                                <div class="form-group">
                                    <label for="Currency">{{$t('form.invoice.currency')}}<span
                                            class="text-danger">*</span></label>
                                    <div>
                                        <v-select :options="currencies" v-model.trim="$v.invoice.Currency.$model"
                                            :reduce="currencies => currencies">
                                        </v-select>

                                        <div class="invalid-feedback custom-validate" v-if="invalidCurrency">
                                            {{$t('form.validation.required')}}</div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="field127">{{$t('form.invoice.invoiceDate')}}<span
                                            class="text-danger">*</span></label>

                                    <date-picker :lang="lang" class="date-picker" v-model="InvoiceDate" valueType="format"
                                        :format="dateFormat" :popup-style="{ top: '100%', left: 0}"
                                        :append-to-body="false">
                                    </date-picker>
                                    <div class="invalid-feedback custom-validate" v-if="invalidDate">
                                        {{$t('form.validation.required')}}</div>
                                </div>

                                <div class="form-group">
                                    <label for="field125">{{$t('form.invoice.dueDate')}}<span
                                            class="text-danger">*</span></label>

                                    <date-picker :lang="lang"  class="date-picker" v-model="InvoiceDueDate" valueType="format"
                                        :format="dateFormat" :popup-style="{ top: '100%', left: 0}"
                                        :append-to-body="false"
                                        >
                                    </date-picker>
                                    <div class="invalid-feedback custom-validate" v-if="invalidDue">
                                        {{$t('form.validation.required')}}</div>
                                </div>

                                <div class="form-group">
                                    <b-form-checkbox id="paid-invoice" v-model="invoice.Paid"
                                        @change="invoicePaid($event)">
                                        {{$t('form.invoice.paid')}}
                                    </b-form-checkbox>
                                </div>

                                <div class="form-group">
                                    <label for="field126">{{$t('form.invoice.paymentDate')}} </label>
                                    <date-picker :lang="lang" class="date-picker" v-model="invoice.PaymentDate" valueType="format"
                                        :format="dateFormat" :popup-style="{ top: '100%', left: 0}"
                                        :append-to-body="false">
                                    </date-picker>
                                </div>

                                <div class="form-group">
                                    <b-form-checkbox id="send-invoice" v-model="invoice.SendInvoice">
                                        {{$t('form.invoice.sendInvoice')}}
                                    </b-form-checkbox>
                                </div>

                                <div class="form-group" v-if="invoice.SendInvoice">
                                <label>{{$t('form.invoice.scheduledDeliveryDate')}}</label>
                                <date-picker :lang="lang" class="date-picker" v-model="InvoiceDeliveryDate" valueType="format"
                                    type="datetime" :format="datetimeFormat" :popup-style="{ left: 0}"
                                    :append-to-body="false">
                                </date-picker>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        required,
        decimal,
        numeric
    } from  'vuelidate/lib/validators';

    export default {
        props: ['permissions', 'dateFormat', 'datetimeFormat'],

        data() {
            return {

                alert: false,
                alertClass: '',
                alertMessage: '',
                invoice_saved:0,
                isLoading: false,
                fullPage: true,
                currentsemester:null,
                request_source: '',
                invalidCurrency: false,
                invalidDate: false,
                invalidDue: false,
                studentName: '',
                studentId: '',
                value: null,
                mbaCourseTitle: null,
                mbaCourseDate: moment().format(this.dateFormat),
                discount: 0,
                course: null,
                defaultAmount: null,
                newPurpose: null,
                administrative_fee: null ,
                application_fee: null ,
                application_fee_checkbox:false,
                administrative_fee_checkbox:false,
                InvoicePurpose:null,

                program: {
                    FullTitle: '',
                    BillingCycle: null,
                    AcceptanceFee: null,
                },
                InvoiceAmount:null,
                InvoiceDate: moment().format(this.dateFormat),
                InvoiceDueDate:null,
                InvoiceDeliveryDate:null,
                InvoiceDeliveryTime:'09:00',
                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },
                invoice: {
                    StudentID: null,
                    InvoicePurpose: null,
                    InvoiceNumber: null,
                    Currency: null,
                    InvoiceDate: moment().format(this.dateFormat),
                    DueDate: null,
                    PaymentDate: null,
                    DeliveryDate: null,
                    SendInvoice: false,
                    Paid: false,
                    MailAddress: 1,
                    acceptanceFee:null,
                    applicationFee:null,
                    excludeScholarshipReduction:null,
                },
                tuitionFee:{
                    administrative_fee: null ,
                    application_fee: null ,
                    billing_cycle: null ,
                    course_fee: null ,
                    created_at: null ,
                    id: null ,
                    no_of_courses: null ,
                    no_of_semesters: 0,
                    program_type: null ,
                    sem_fees:[],
                    status: null ,
                    total_fee: null ,
                },
                max_semesters:20,
                tuition_fee_cycle:null,
                tuition_semesters:[],
                currencies: [],
                invoicePurposes: [],
                students: [],
                programs: [],
                courses: [],
                semesters: [],
                mbaCourse: [],
                student:{},
                previous_path:null,
            }
        },
         validations: {
            InvoiceAmount: {
                    required
                },
            InvoiceDate: {
                    required
                },
            InvoiceDueDate: {
                    required
            },
            invoice: {

                Currency: {
                    required
                },

            },
            studentName: {
                required
            },
            program: {
                FullTitle:{required}
            }
        },

        beforeRouteLeave (to, from, next) {
                    this.studentName=null
                    this.student={}
                    this.program={}
                    this.invoice={}
                    next()
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                var previous_path = from.path;
                if(previous_path== '/'){
                    localStorage.setItem('create-invoice-from-student',false)
                }
                vm.previous_path = previous_path;
                if(JSON.parse(localStorage.getItem('create-invoice-from-student').toLowerCase())){
                    vm.getStudent();
                }else{
                    vm.student={}
                    vm.program={}
                    vm.invoice={}
                 }
            })
        },

        mounted() {
            if (!this.permissions.createInvoicesStudents) {
                return this.$router.push('/');
            }


            this.getPrograms();
           this.getInitialData();

        },


        watch: {
            invoice: {
                handler(val){
                    if(val.SendInvoice == false || val.SendInvoice == null || val.SendInvoice == undefined){
                     this.emptyDeliveryDate()
                    return;
                    }else {
                    return;
                    }
                },
                deep: true
            },
        },

        methods: {
            addSeperator(e)
            {
                if(e.code === 'Enter' || e.type === 'blur')
                {
                    this.InvoiceAmount = toThousandSeparator(this.InvoiceAmount);
                }
            },
            emptyDeliveryDate(){

            this.InvoiceDeliveryDate = undefined

            },
            showAcceptanceFee($event){
                if($event!=true){
                    this.currentsemester=null;
                    let Amount =this.discountedAmount;
                    Amount = Number(Amount);
                    this.InvoiceAmount= toThousandSeparator(Amount);
                    this.InvoicePurpose=null
                }else{
                    this.application_fee_checkbox=false;
                    if(this.tuition_fee_cycle!='program'){
                        if(this.tuitionFee.administrative_fee!=null && this.tuitionFee.administrative_fee!=0 && this.tuitionFee.administrative_fee!=false){
                            let Amount=this.tuitionFee.administrative_fee;
                            this.InvoiceAmount=  toThousandSeparator (Amount);
                            // this.invoice.acceptanceFee=true;
                        }else{
                            let Amount=this.discountedAmount;
                             Amount = Number(Amount);
                            this.InvoiceAmount= toThousandSeparator(Amount);
                        }
                    }else{
                            let Amount=this.program.AcceptanceFee==null ||this.program.AcceptanceFee==false ? 0:this.program.AcceptanceFee
                            this.InvoiceAmount= toThousandSeparator(Amount);
                            // this.invoice.acceptanceFee=true;

                    }
                    // this.application_fee=false;
                    let purpose = this.$t('form.invoice.acceptancePurpose', {

                    programType: this.program.ProgramType,
                    program: this.program.ProgramTitle

                    });

                    // if (!this.invoicePurposes.includes(purpose)) {
                    // this.invoicePurposes.unshift(purpose);
                    // }

                    this.InvoicePurpose = purpose
                }


            },

            getStudent() {
                axios
                    .get(`/api/students/${localStorage.getItem('finance-tab')}`)
                    .then(response => {
                        let student = response.data;
                        this.student = student;
                        this.discount = student.GlobalDiscount;
                        this.studentName = `${student.StudentNumber} - ${student.FirstName} ${student.LastName}`;
                        this.invoice.StudentID = student.ID;

                        this.invoice.MailAddress = student.MailAddress ? student.MailAddress : 1;

                        this.setProgram(student);
                    })
                    .catch(error => {
                        console.log('error fetching student');
                    })
            },

            getInitialData() {
                this.isLoading = true;
                axios
                    .get('/api/invoices/get-initial-data')
                    .then(response => {
                        this.isLoading = false;

                        this.invoice.InvoiceNumber = response.data.invoice_number;
                        this.InvoiceAmount = toThousandSeparator(response.data.amount);
                        this.defaultAmount = response.data.amount;
                        this.invoice.Currency = response.data.default_currency;
                        this.InvoiceDueDate = this.getDueDate(response.data.due_date_duration);
                        this.InvoiceDate = moment().format(this.dateFormat);
                        this.invoicePurposes = Object.values(response.data.invoice_purposes);
                        this.currencies = response.data.currencies;

                        // response.data.mba_programs.forEach(p => {
                        //     p.FullName = this.$options.filters.program(p);
                        //     this.mbaCourse.push(p);
                        // });
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('[ get-initial-data ]', error);
                    });
            },

            getPrograms() {
                axios
                    .get("/api/programs?full")
                    .then(response => {
                        this.programs = response.data;
                        this.programs.map(p => p.FullTitle = this.$options.filters.program(p));
                    })
                    .catch(error => console.log('error fetching programs'));
            },
            getProgramType() {

                axios
                    .post("/api/program-type", {
                        programType: this.program.ProgramType,
                        programID:this.program.ID,
                        student:this.student
                    })
                    .then(response => {
                        let Amount=response.data.data.discounted_amount
                        this.discountedAmount=Amount.toFixed(2);
                        this.InvoiceAmount = toThousandSeparator(Amount);
                        this.tuition_fee_cycle=response.data.data.tuition_fee_details;

                        if(this.tuition_fee_cycle!='program'){
                            this.tuitionFee=this.tuition_fee_cycle
                            this.tuition_fee_cycle=this.tuition_fee_cycle.billing_cycle

                        }
                        //
                        if(this.tuition_fee_cycle!='program' && this.tuition_fee_cycle=='term'){
                        for(var i=0;i<this.tuitionFee.sem_fees.length;i++){
                            this.tuition_semesters.push(this.tuitionFee.sem_fees[i].semester_no);
                        }
                        this.semesters = this.tuition_semesters;
                        }

                        if(this.tuition_fee_cycle=='program' || this.tuition_fee_cycle=='course'){
                        this.getCourses();
                        }
                    })
                    .catch(error => console.log(error));
            },

            programSelected() {
                if (!this.program) {
                    this.program = {
                        FullTitle: '',
                        BillingCycle: null,
                        AcceptanceFee: null,
                    };

                    this.InvoiceAmount = toThousandSeparator(this.defaultAmount);
                    this.course = null;
                    return;
                }
                if(this.studentName=='' || this.studentName==null){
                this.InvoiceAmount = toThousandSeparator(this.defaultAmount);
                }

            },
            selectedStudent(student) {
                this.clear();
                this.student=student;
                this.discount = student.GlobalDiscount;
                this.studentName = `${student.StudentNumber} - ${student.FirstName} ${student.LastName}`;
                this.invoice.StudentID = student.ID;

                this.invoice.MailAddress = student.MailAddress ? student.MailAddress : 1;

                this.setProgram(student);
            },

            setProgram(student) {
                if (student && student.programs.length) {
                    student.programs[0].FullTitle = this.$options.filters.program(student.programs[0]);
                    this.program = student.programs[0];
                    this.getProgramType();
                }
            },
            getCourses() {
                this.isLoading = true;

                axios
                    .get(`/api/programs/${this.program.ID}/courses`)
                    .then(response => {

                        if (response.data.length) {
                            this.courses = response.data;
                            this.courses.map(c => {
                                c.FullTitle = `${c.CourseCode} - ${c.CourseTitle}`;
                                c.Semester = c.pivot.Semester;
                                c.Fee = c.pivot.Fee;
                            })
                            this.fetchSemesters();
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log('error');
                        this.isLoading = false;
                    });
            },

            selectedCourse(course) {

                try {
                if (!course) {
                    if(!this.program && (this.studentName=='' || this.studentName==null)){
                    this.invoice.InvoicePurpose = null;
                    this.InvoiceAmount = toThousandSeparator(this.defaultAmount);
                    }else{
                        this.getProgramType();
                    }
                }
                if(course){

                if(this.tuition_fee_cycle=='program'){
                // set amount
                if (course.Fee && course.Fee > 0){
                    this.InvoiceAmount = course.Fee;
                }else{
                    this.InvoiceAmount = 0;
                }
                }
                if(this.tuition_fee_cycle=='course'){
                   this.InvoiceAmount = this.tuitionFee.course_fee;
                }
                // set invoice purpose for selected course
                let purpose = this.$t('form.invoice.coursePurpose', {
                    course: course.CourseTitle,
                    programType:this.program.ProgramType,
                    program: this.program.ProgramTitle
                });

                this.newPurpose = purpose
                }
            } catch (error) {
                console.log(error);
            }

            },

            fetchSemesters() {
                let semesters = [];
                this.courses.forEach(c => {
                    let s = parseInt(c.Semester);
                    if (s) semesters.push(s);
                });

                this.semesters = [...new Set(semesters)].sort();
            },

            selectedSemester(semester) {

                this.currentsemester=semester;
                if (!semester) {
                    if(!this.program && (this.studentName=='' || this.studentName==null)){
                    this.invoice.InvoicePurpose = null;
                    this.InvoiceAmount = toThousandSeparator(this.defaultAmount);
                    }else{
                        this.getProgramType();
                    }
                }
                 if (semester) {
                // set amount
                if(this.tuition_fee_cycle=='program'){
                if (this.program.TermFee[semester - 1] && this.program.TermFee[semester - 1] > 0)
                    this.InvoiceAmount = this.program.TermFee[semester - 1];
                }else if(this.tuition_fee_cycle=='term'){
                    for(var i=0;i<this.tuitionFee.sem_fees.length;i++){
                       if(semester==this.tuitionFee.sem_fees[i].semester_no){
                           this.InvoiceAmount = toThousandSeparator(this.tuitionFee.sem_fees[i].tuition_fee);
                       }
                    }

                }

                // set invoice purpose for selected course
                let purpose = this.$t('form.invoice.termPurpose', {
                    semester: semester,
                    programType: this.program.ProgramType,
                    program: this.program.ProgramTitle
                });

                // if (!this.invoicePurposes.includes(purpose)) {
                //     this.invoicePurposes.unshift(purpose);
                // }

                this.newPurpose = purpose;
                 }
            },

            invoicePaid(isChecked) {
                if (isChecked) {
                    this.invoice.PaymentDate = moment().format(this.dateFormat);
                }
            },

            addPurpose() {
                if (!this.newPurpose) {
                    return;
                }

                if (!this.invoicePurposes.includes(this.newPurpose)) {
                    this.invoicePurposes.unshift(this.newPurpose);
                    this.saveInvoicePurposes();
                }

                this.InvoicePurpose = this.newPurpose;

                this.newPurpose = null;
            },

            saveInvoicePurposes() {
                axios
                    .post("/api/settings?name=invoice-purposes", {
                        value: this.invoicePurposes
                    })
                    .then(response => {})
                    .catch(error => {});
            },

            searchStudent() {

                if (this.studentName == '') {
                    this.clear();
                    return;
                }

                let source = axios.CancelToken.source();

                if (this.request_source != '')
                    this.request_source.cancel('Operation canceled by the user.');

                this.request_source = source;

                axios
                    .get(`/api/students?nameOrNumber=${this.studentName}`)
                    .then(resp => this.students = resp.data.data.data)
                    .catch(error => {console.log(error)});
            },

            clear() {
                this.students = [];
                this.studentName = '';
            },



            createInvoice() {
                this.closeAlert();

                this.invalidCurrency = this.invoice.Currency == null ? true : false;
                this.invoice.acceptanceFee = this.administrative_fee_checkbox;
                this.invoice.applicationFee = this.application_fee_checkbox;
                if(this.newPurpose == '')
                this.newPurpose = null;
                if(this.InvoicePurpose == '')
                this.InvoicePurpose = null;
                this.$v.$touch();

                if (this.$v.$invalid || (this.InvoicePurpose == null && this.newPurpose == null)) {

                    let errorMsg = '';

                    if(this.$v.InvoiceAmount.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.amount'): this.$t('form.invoice.amount');
                    };

                    if(this.$v.invoice.Currency.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.currency'): this.$t('form.invoice.currency');
                    };


                    if(this.$v.InvoiceDate.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.invoiceDate'): this.$t('form.invoice.invoiceDate');
                    };

                    if(this.$v.InvoiceDueDate.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.dueDate'):this.$t('form.invoice.dueDate');
                    };
                    if(this.$v.studentName.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.student'): this.$t('form.invoice.student');
                    };

                    if(this.$v.program.FullTitle.$error){
                        errorMsg = errorMsg ? errorMsg +", "+ this.$t('form.invoice.program'):this.$t('form.invoice.program');
                    };

                    if(this.InvoicePurpose == null && this.newPurpose == null){
                        errorMsg = errorMsg ? errorMsg +", "+ this.$t('form.invoice.invoicePurpose'):this.$t('form.invoice.invoicePurpose');
                    }

                    this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');

                    this.$v.$reset();

                    return;

                }
                if(this.newPurpose && this.InvoicePurpose){
                    if(confirm(this.$t('form.invoice.purposeOverwrittenWarning'))){

                    this.invoice.InvoicePurpose = this.InvoicePurpose ? this.InvoicePurpose :this.newPurpose;
                    this.newPurpose = null;

                    }else{

                        return;

                    }
                }else{
                    this.invoice.InvoicePurpose = this.InvoicePurpose ? this.InvoicePurpose :this.newPurpose;
                }
                this.isLoading = true;

                this.invoice.Amount = removeThousandSeparator(this.InvoiceAmount);
                this.invoice.DueDate = this.InvoiceDueDate
                this.invoice.InvoiceDate = this.InvoiceDate;
                this.invoice.DeliveryDate = this.InvoiceDeliveryDate;
                this.invoice.Installment = this.currentsemester;
                if(this.course){
                this.invoice.course = this.course
                }
                /**/
                axios
                    .post('/api/invoices', this.invoice)
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.success) {
                            this.showAlert(response.data.message);
                            this.saveInvoicePurposes();
                            this.invoice_saved=1;
                            if(JSON.parse(localStorage.getItem('create-invoice-from-student').toLowerCase())){
                                setTimeout(() => {
                                    this.$router.push(this.previous_path);
                                }, 2000);
                            }else{
                                setTimeout(() => {
                                    this.$router.push({
                                        name: 'StudentInvoiceIndex'
                                    });
                                }, 2000);
                            }

                        }

                        if (response.data.error) {

                            this.showAlert(response.data.message, 'danger');
                            this.isLoading = false;
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;

                        if(error.response)
                        {
                             this.showAlert(error.response.data?.message, 'danger');
                        }

                    });
            },

            getDueDate(days) {
                days = parseInt(days);
                return moment().add(days, 'days').format(this.dateFormat);
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },
             closeAlert() {
                this.alert = false;
            }
        }
    }

</script>
<style scoped>
    .custom-validate {
        display: block !important;
    }

</style>
